<template>
    <div>
        <div class="dashboard-card light upcoming-appt no-appt" v-if="display === 'explainer'">
            <div class="row row-eq-height">
                <div class="col-12 col-md-4 text-center d-md-none d-lg-none d-xl-block">
                    <img class="upcoming__img img-fluid" src="@/assets/img/computer@2x.png" alt="BetterMynd">
                </div>
                <div class="col-12 col-xl-8">
                    <div class="vertical-align-md">
                        <div class="holder">
                            <label>SESSION REMINDERS</label>
                            <p style="font-size: 17px;">
                                The video-camera icon will be displayed here <b>15-minutes prior to your scheduled
                                session times</b>, allowing you to access your secure video-therapy session
                                with your client.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dashboard-card light upcoming-appt" v-if="display === 'session'">
            <div class="row row-eq-height">
                <div class="col-12 col-md-4 text-center d-md-none d-lg-none d-xl-block">
                    <img class="upcoming__img img-fluid" src="@/assets/img/computer@2x.png" alt="BetterMynd">
                </div>
                <div class="col-12 col-xl-8">
                    <div class="vertical-align-md">
                        <div class="holder">
                            <label>SESSION REMINDER</label>
                            <h2>{{ displayed_join.session.when | format('MMMM Do hh:mm A') }}</h2>
                            <p>
                                with
                                <router-link :to="`/student/${displayed_join.session.client.userId}`">
                                    {{ displayed_join.session.client.firstName }}
                                    {{ displayed_join.session.client.lastName }}
                                </router-link>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-2">
                    <a :href="displayed_join.join_url" target="_blank" class="icon-btn">
                        <button class="btn btn-primary btn-block w-100" type="button">
                            Join Session
                            <font-awesome-icon :icon="['fas', 'video']" class="icon alt pulse" />
                        </button>
                    </a>
                </div>
            </div>
        </div>
        <div class="dashboard-card light upcoming-appt" v-if="display === 'workshop'">
            <div class="row row-eq-height">
                <div class="col-12 col-md-4 text-center d-md-none d-lg-none d-xl-block">
                    <img class="upcoming__img img-fluid" src="@/assets/img/computer@2x.png" alt="BetterMynd">
                </div>
                <div class="col-12 col-xl-8">
                    <div class="vertical-align-md">
                        <div class="holder">
                            <label>WORKSHOP REMINDER</label>
                            <h2>{{ displayed_join.workshop.startTime | format('MMMM Do hh:mm A') }}</h2>
                            <p>{{ displayed_join.workshop.topic  }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-2">
                    <a :href="displayed_join.join_url" target="_blank" class="icon-btn">
                        <button class="btn btn-primary btn-block w-100" type="button">
                            Join Workshop
                            <font-awesome-icon :icon="['fas', 'video']" class="icon alt pulse" />
                        </button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import moment from 'moment'
import MeetingsClient from '@/api/MeetingsClient';
import WorkshopClient from '@/api/WorkshopClient';
import SessionClient from '@/api/SessionClient';

export default {
    data() {
        return {
            sessions: [],
            workshops:[],

            meetingsClient: new MeetingsClient(this.$http),
            workshopsClient: new WorkshopClient(this.$http),
            sessionsClient: new SessionClient(this.$http),

            counselorId: this.$store.getters.currentUser.counselor_profile.id,

            displayed_join: {
                session: null,
                workshop: null,
                url: null,
            },
            timeouts: { }
        }
    },
    computed:{
        display() {
            if(this.displayed_join.session) 
                return 'session';
            if(this.displayed_join.workshop)
                return 'workshop';
            return 'explainer';
        },
    },
    beforeDestroy() {
        for(const key in this.timeouts) {
            clearTimeout(this.timeouts[key]);
        }
    },
    async mounted() {
        await this.tryKeepSessionCacheUpToDate();
        await this.tryKeepWorkshopCacheUpToDate();
        await this.tryFetchJoinUrlAndRePoll();
    },
    methods: {
        async tryKeepSessionCacheUpToDate() {
            const from = moment().subtract(50, 'minutes');
            const through = moment().endOf('day');

            const response = await this.sessionsClient.getSessionsForCounselor(
                this.counselorId,
                undefined,
                from.toISOString(),
                through.toISOString(),
                5,
                'ListSessionsByStartTimeAscending',
                false);
            this.sessions = response.sessions
              .sort((a,b) => moment(a.when).diff(moment(b.when)))
              .map(x => ({
                  ...x,
                  when: moment(x.when)
              }));
            
            const fifteenMinutes = 1000 * 60 * 15;
            this.timeouts['tryKeepSessionCacheUpToDate'] 
                = setTimeout(this.tryKeepSessionCacheUpToDate.bind(this), fifteenMinutes);
        },
        async tryKeepWorkshopCacheUpToDate() {
            const from = moment().subtract(50, 'minutes');
            const through = moment().endOf('day');

            const response = await this.workshopsClient.listForCounselor(
                undefined,
                this.counselorId,
                from.toISOString(),
                through.toISOString(),
                undefined,
                undefined,
            );
            this.workshops = response.workshops
              .sort((a, b) => moment(a.startTime).diff(moment(b.startTime)))
              .map(x => ({
                  ...x,
                  startTime: moment(x.startTime),
                  endTime: moment(x.endTime)
              }));

            const fifteenMinutes = 1000 * 60 * 15;
            this.timeouts['tryKeepSessionCacheUpToDate'] 
                = setTimeout(this.tryKeepSessionCacheUpToDate.bind(this), fifteenMinutes);
        },
        async tryFetchJoinUrlAndRePoll() {
            const activeSession = this.getActiveSession();
            const activeWorkshop = this.getActiveWorkshop();

            let changedSession = (activeSession ? activeSession.id : null) != (this.displayed_join.session ? this.displayed_join.session.id : null);
            let changedWorkshop = (activeWorkshop ? activeWorkshop.id : null) != (this.displayed_join.workshop ? this.displayed_join.workshop.id : null);

            this.displayed_join = {
              ...this.displayed_join,
              session: activeSession,
              workshop: activeWorkshop,
            }

            if(changedSession || changedWorkshop) {
                try {
                    if(this.displayed_join.session)
                        this.displayed_join.join_url = await this.meetingsClient.join(activeSession.meetingId);
                    else if (this.displayed_join.workshop)
                        this.displayed_join.join_url = await this.meetingsClient.join(this.displayed_join.workshop.meetingId);
                } catch(ex) {
                    console.error(ex);
                    this.displayed_join = {
                        session: null,
                        workshop: null,
                        join_url: null,
                    }
                }
            }

            this.$forceUpdate();

            const fifteenSeconds = 1000 * 15;
            this.timeouts['tryFetchJoinUrlAndRePoll'] 
                = setTimeout(this.tryFetchJoinUrlAndRePoll.bind(this), fifteenSeconds);
        },
        getActiveSession() {
            for(const session of this.sessions) {
                const start = moment(session.when).subtract(15, 'minutes');
                const end = moment(session.when).add(50, 'minute');
                const now = moment();
                if(now >= start && now < end)
                    return session;
            }
            
            return null;
        },
        getActiveWorkshop() {
            for(const workshop of this.workshops) {
                const start = moment(workshop.startTime).subtract(15, 'minutes');
                const end = moment(workshop.endTime);
                const now = moment();
                if(now >= start && now < end)
                    return workshop;
            }
            return null;
        },
    },
}
</script>
  
<style></style>